import React from "react";
import { useI18n } from "@/lib/i18n";

export default function Process() {
  const { t } = useI18n();
  return (
    <section data-testid="process-section" className="relative bg-charcoal py-24 lg:py-40">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-12 gap-6 mb-16">
          <div className="col-span-12 lg:col-span-7">
            <div className="eyebrow mb-6 flex items-center gap-3">
              <span className="w-8 h-px bg-brass" /> {t.process.eyebrow}
            </div>
            <h2 className="font-display text-[2.4rem] sm:text-5xl lg:text-6xl text-bone leading-[1] tracking-tight">
              {t.process.title_1} <span className="italic-display text-brass">{t.process.title_2}</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-px bg-bone/5 border border-bone/5">
          {t.process.list.map((p, i) => (
            <div key={i} data-testid={`process-step-${i}`} className="bg-charcoal p-7 min-h-[220px] flex flex-col group hover:bg-onyx transition-colors duration-500">
              <div className="font-display text-5xl lg:text-6xl text-brass leading-none">0{i + 1}</div>
              <div className="mt-auto pt-6">
                <h3 className="font-display text-xl lg:text-2xl text-bone tracking-tight">{p.t}</h3>
                <p className="mt-2 text-sm text-bone/60 leading-relaxed">{p.d}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
